<template>
    <v-card class="my-2 px-2">
        <v-card-text>
            <v-alert
                border="top"
                color="error darken-2"
                outlined
                icon="mdi-alert"
                v-if="eviction.filtered"
            >
                <v-chip small color="error darken-2" class="mr-2"
                    >FILTERED</v-chip
                >{{ eviction.meta.description }}
            </v-alert>
            <div v-if="mode === 'print'" class="d-flex justify-end">
                <span v-if="eviction.exclude" class="font-weight-bold"><v-icon color="warning" class="mr-1">mdi-alert</v-icon>Student excluded record from report on {{eviction.exclude_date}}</span>
            </div>
            <div v-else class="d-flex justify-end">
                <v-checkbox v-model="exclude"  label="This is not me - remove from report" color="primary" @change="$emit('exclude',eviction.id)" />
             </div>
            <v-divider class="my-2" color="grey"></v-divider>
            <div class="mx-3" style="width: 100%">
                <div class="d-flex align-center">
                    <v-avatar
                        size="40"
                        color="error darken-2"
                        rounded
                        class="mr-3"
                    >
                        <div class="d-flex flex-column">
                            <v-icon size="25" class="white--text"
                                >mdi-home-export-outline</v-icon
                            >
                        </div>
                    </v-avatar>
                    <h3>
                        {{ $_.get(eviction, "case.case.caseTitle") }}
                    </h3>
                </div>

                <div class="d-flex mt-3">
                    <v-spacer></v-spacer>
                    <v-chip
                        small
                        class="text-uppercase grey--text text--darken-1"
                        >{{ eviction.tag.status }}</v-chip
                    >
                </div>
                <v-divider class="my-2" color="grey"></v-divider>
                <div class="d-flex">
                    <span class="d-inline" style="width: 120px"
                        >Full Name:</span
                    >
                    <span class="font-weight-bold">
                        {{ eviction.case.fullName }}
                    </span>
                </div>
                <div class="d-flex">
                    <span class="d-inline" style="width: 120px">Address:</span>
                    <span class="font-weight-bold"
                        >{{ details.address1 }}
                    </span>
                </div>

                <v-divider class="my-2" color="grey"></v-divider>
                <div class="mt-2">
                    <h4 class="mb-1">Dates</h4>
                    <template
                        v-for="({ icon, date, from, label }, index) in [
                            eviction.fileDate,
                        ]"
                    >
                        <div class="d-flex" :key="index">
                            <v-icon class="mr-3">{{ icon }}</v-icon>
                            <span class="d-inline mr-3" style="width: 120px">{{
                                label
                            }}</span>
                            <h4>{{ date ? date : "" }}</h4>
                            <v-spacer></v-spacer>
                            <v-chip small>{{ from }}</v-chip>
                        </div>
                        <v-divider
                            class="my-2"
                            color="grey ligthen-2"
                            :key="`divider-${index}`"
                        ></v-divider>
                    </template>
                </div>
                <div class="mt-2">
                    <h4 class="mb-1">Details</h4>
                    <template
                        v-for="(
                            { icon, label, text, type }, index
                        ) in eviction.info"
                    >
                        <div class="d-flex" :key="index">
                            <v-icon class="mr-3">{{ icon }}</v-icon>
                            <v-chip
                                label
                                small
                                class="mr-3"
                                color="grey lighten-4"
                                style="width: 160px"
                                >{{ label }}</v-chip
                            >
                            <v-spacer></v-spacer>
                            <v-chip
                                v-if="type === 'chip'"
                                color="secondary"
                                dark
                                small
                                class="text-uppercase font-weight-bold"
                                >{{ text }}</v-chip
                            >
                            <span v-else class="font-weight-bold">{{
                                text
                            }}</span>
                        </div>
                        <v-divider
                            class="my-2"
                            color="grey ligthen-2"
                            :key="`divider-${index}`"
                        ></v-divider>
                    </template>
                </div>
            </div>
        </v-card-text>
        <v-card-actions>
            <div class="mx-3">
                <span
                    class="
                        grey-text
                        text--lighten-1
                        font-weight-light
                        text-caption
                        d-block
                    "
                    >Source: {{ details.source }}</span
                >
                <span
                    class="
                        grey-text
                        text--lighten-1
                        font-weight-light
                        text-caption
                        d-block
                    "
                    >Import Date: {{ details.importDate }}</span
                >
            </div>
            <v-spacer></v-spacer>
            <v-btn v-if="mode === 'screen'" small color="secondary" class="mr-3"
                >More Details</v-btn
            >
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    name: "screen-eviction",
    components: {},
    props: {
        eviction: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: false,
            default: "screen",
        },
    },
    data() {
        return {
            exclude: false,
        };
    },
    computed: {
        details() {
            return this.$_.get(this.eviction, "case", {});
        },
    },
};
</script>

<style scoped>
</style>